import {Types} from 'mongoose';
import {CallDirectionPlacetel} from '@/enums/api-handler/placetel/CallDirection.placetel';
import {HangupTypesPlacetel} from '@/enums/api-handler/placetel/HangupTypes.placetel';

/** Live events of a Placetel call for the person on the phone (Anruf-Fenster); copy of shrd PlacetelEvents */
export enum PlacetelEvents {
    CALL_STARTED = 'placetel:call-started',
    CALL_ACCEPTED = 'placetel:call-accepted',
    CALL_ENDED = 'placetel:call-ended',
    /** Client only: a protocol was saved / dismissed in the Anruf-Fenster (counter in the app bar) */
    PROTOCOL_CHANGED = 'placetel:protocol-changed',
}

export type PlacetelCallEventPayload = {
    /** PlacetelCall document */
    id: Types.ObjectId | string;
    callId: string;
    direction: CallDirectionPlacetel;
    /** Number of the other party (international format) */
    number?: string;
    /** Own line of the call (the direct number the other party sees and calls back) */
    lineNumber?: string;
    otherParty?: Types.ObjectId | string;
    /** CrudEntityTypes of the profile: parents / employees / institutions / students / responsibles (Ansprechpartner:in) */
    otherPartyType?: string;
    startedAt: Date | string;
    durationInSeconds?: number;
    hangupType?: HangupTypesPlacetel;
};
